import { useEffect, useMemo, useState } from "react";

import Table from "@mui/material/Table";
import TableBody from "@mui/material/TableBody";
import TableCell from "@mui/material/TableCell";
import TableContainer from "@mui/material/TableContainer";
import TableHead from "@mui/material/TableHead";
import TableRow from "@mui/material/TableRow";
import Paper from "@mui/material/Paper";
import {
    Box,
    Pagination,
    Skeleton,
    TableSortLabel,
    useMediaQuery,
} from "@mui/material";
import ReceiptIcon from "@mui/icons-material/Receipt";

import style from "./HistoryTransactions.module.scss";

import dayjs from "dayjs";
import "dayjs/locale/ru"; // для русского языка
import { usePaymentsStore } from "../../../store/payments.store";
import { PaymentsMethods } from "../../../configs/payments-methods.config";
dayjs.locale("ru");

export function HistoryTransactions() {
    const isMobile = useMediaQuery("(max-width:1100px)");
    const isSmallMobile = useMediaQuery("(max-width:700px)");

    const { getTransactions, transactions, total_transactions } =
        usePaymentsStore();

    const [loading, setLoading] = useState(true);

    const [order, setOrder] = useState<"asc" | "desc">("desc");
    const [page, setPage] = useState(1);

    const handleSortDate = () => {
        setOrder((prev) => (prev === "asc" ? "desc" : "asc"));
    };

    useEffect(() => {
        (async () => {
            try {
                setLoading(true);
                await getTransactions((page - 1) * 20, order.toUpperCase());
            } catch (error) {
            } finally {
                setLoading(false);
            }
        })();
    }, [page, order]);

    return (
        <Box>
            <h1
                style={{
                    marginBottom: "30px",
                }}
            >
                История платежей
            </h1>
            <TableContainer
                component={Paper}
                sx={{
                    maxWidth: isMobile ? "calc(100vw - 48px)" : "100%",
                    overflowX: "auto",
                }}
            >
                <Table>
                    <TableHead>
                        <TableRow>
                            <TableCell sortDirection={order}>
                                <TableSortLabel
                                    active
                                    direction={order}
                                    onClick={handleSortDate}
                                >
                                    Дата
                                </TableSortLabel>
                            </TableCell>
                            <TableCell align="right">Сумма</TableCell>
                            {!isSmallMobile && (
                                <TableCell align="right">
                                    Способ оплаты
                                </TableCell>
                            )}
                            <TableCell></TableCell>
                        </TableRow>
                    </TableHead>
                    {loading ? (
                        <TableBody>
                            {Array(10)
                                .fill(10)
                                .map((n, v) => {
                                    return (
                                        <TableRow key={v}>
                                            <TableCell>
                                                <Skeleton variant="text" />
                                            </TableCell>
                                            <TableCell align="right">
                                                <Skeleton
                                                    variant="text"
                                                    style={{
                                                        marginLeft: "auto",
                                                        display: "inline-block",
                                                        width: "100px",
                                                    }}
                                                />
                                            </TableCell>
                                            <TableCell align="right">
                                                <Skeleton
                                                    variant="text"
                                                    style={{
                                                        marginLeft: "auto",
                                                        display: "inline-block",
                                                        width: "100px",
                                                    }}
                                                />
                                            </TableCell>
                                            <TableCell align="right">
                                                <Skeleton
                                                    variant="text"
                                                    style={{
                                                        marginLeft: "auto",
                                                        display: "inline-block",
                                                        width: "140px",
                                                    }}
                                                />
                                            </TableCell>
                                        </TableRow>
                                    );
                                })}
                        </TableBody>
                    ) : (
                        <TableBody>
                            {transactions.map((row, i) => (
                                <TableRow key={i}>
                                    <TableCell>
                                        {
                                            dayjs(row.created_at)
                                                .format("D MMMM")
                                                .split(",")[0]
                                        }
                                        <span
                                            style={{
                                                color: "#82809c",
                                            }}
                                        >
                                            ,
                                            {dayjs(row.created_at).format(
                                                " YYYY г.",
                                            )}
                                        </span>
                                        {isSmallMobile && (
                                            <div
                                                style={{
                                                    color: "#82809c",
                                                }}
                                            >
                                                {
                                                    PaymentsMethods[
                                                        row.payment_method
                                                    ]
                                                }
                                            </div>
                                        )}
                                    </TableCell>
                                    <TableCell align="right">
                                        {row.amount.toFixed(2)}₽
                                    </TableCell>
                                    {!isSmallMobile && (
                                        <TableCell align="right">
                                            {
                                                PaymentsMethods[
                                                    row.payment_method
                                                ]
                                            }
                                        </TableCell>
                                    )}
                                    <TableCell align="right">
                                        {row.receipt_url && (
                                            <a
                                                href={row.receipt_url}
                                                className={
                                                    style.info__payment__link
                                                }
                                                target="_blank"
                                                rel="noopener noreferrer"
                                            >
                                                <ReceiptIcon
                                                    sx={{
                                                        width: 13,
                                                    }}
                                                />
                                                {!isSmallMobile && (
                                                    <>Информация о платеже</>
                                                )}
                                            </a>
                                        )}
                                    </TableCell>
                                </TableRow>
                            ))}
                        </TableBody>
                    )}
                </Table>
                <Box
                    sx={{
                        display: "flex",
                        justifyContent: "center",
                    }}
                >
                    <Pagination
                        sx={{
                            marginTop: "16px",
                            marginBottom: "16px",
                        }}
                        count={
                            Math.floor(total_transactions / 20) +
                            (total_transactions % 20 == 0 ? 0 : 1)
                        }
                        page={page}
                        onChange={(e, p) => setPage(p)}
                    />
                </Box>
            </TableContainer>
        </Box>
    );
}
